import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
export var useTranslationHook = function useTranslationHook(labels) {
  var _React$useState = React.useState(labels),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      resourceBundle = _React$useState2[0],
      setResourceBundle = _React$useState2[1];

  React.useEffect(function () {
    setResourceBundle(labels);
  }, [labels]);

  var t = function t(key) {
    var translatedValue; //this should never be the case, but check to see if we have a resource bundle

    if (!resourceBundle) {
      translatedValue = key;
    } else {
      translatedValue = resourceBundle[key] ? resourceBundle[key] : key;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length > 0) {
      translatedValue = replacePlaceholders(translatedValue, args);
      return translatedValue;
    }

    return translatedValue;
  };

  var replacePlaceholders = function replacePlaceholders(translatedValue, values) {
    try {
      var index = -1;
      return values.reduce(function (previous, value) {
        index++;
        return previous.replace("{".concat(index, "}"), value);
      }, translatedValue);
    } catch (error) {
      return translatedValue;
    }
  };

  return {
    t: t,
    setResourceBundle: setResourceBundle,
    resourceBundle: resourceBundle
  };
};